import { useTheme } from '@flowcore-water/ui';

interface PaginationProps {
  page: number;
  pages: number;
  total: number;
  onPageChange: (page: number) => void;
}

export function Pagination({ page, pages, total, onPageChange }: PaginationProps) {
  const { t } = useTheme();

  if (pages <= 1) return null;

  return (
    <div className="flex items-center justify-between py-3">
      <span className="text-xs" style={{ color: t.textMuted }}>
        {total.toLocaleString()} records — page {page} of {pages}
      </span>
      <div className="flex gap-1">
        <PageButton
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          label="← Prev"
        />
        {page > 2 && (
          <PageButton onClick={() => onPageChange(1)} label="1" />
        )}
        {page > 3 && <span style={{ color: t.textMuted }} className="px-1">…</span>}
        {page > 1 && (
          <PageButton onClick={() => onPageChange(page - 1)} label={String(page - 1)} />
        )}
        <PageButton active label={String(page)} />
        {page < pages && (
          <PageButton onClick={() => onPageChange(page + 1)} label={String(page + 1)} />
        )}
        {page < pages - 2 && <span style={{ color: t.textMuted }} className="px-1">…</span>}
        {page < pages - 1 && (
          <PageButton onClick={() => onPageChange(pages)} label={String(pages)} />
        )}
        <PageButton
          disabled={page >= pages}
          onClick={() => onPageChange(page + 1)}
          label="Next →"
        />
      </div>
    </div>
  );
}

function PageButton({
  label,
  active,
  disabled,
  onClick,
}: {
  label: string;
  active?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}) {
  const { t } = useTheme();

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="rounded px-2.5 py-1 text-xs font-medium transition-colors"
      style={{
        background: active ? t.accentBg : t.buttonBg,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: active ? t.accent : t.buttonBorder,
        color: active ? t.accent : disabled ? t.textMuted : t.buttonText,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      {label}
    </button>
  );
}
